module.exports = {
  ModuleName: 'Module name',
  OperationChangeTime: 'Operation change time',
  Operator: 'Operator',
  To: 'To',
  Close: 'Close',
  SerialNumber: 'Serial number',
  OperationTime: 'Operation time',
  QueryScheme: 'Query scheme',
  QuickSearchBusinessCode: 'Quick search: Business code',
  YouDidntOpen: 'You didn\'t open',
  FinancialAudit: 'Financial audit',
  ModulePermissions: 'Module permissions',
  IfTheDataLoadingYears: 'If the selected date range is more than 2 years, it will affect the data loading speed, are you sure to query the data beyond 2 years?',
  StartDate: 'Start date',
  EndDate: 'End date',
  ContentDescription: 'Content description',
  Name: 'Name'
}
